import { render, staticRenderFns } from "./shiftReport.vue?vue&type=template&id=5b6e64e7&scoped=true&"
import script from "./shiftReport.vue?vue&type=script&lang=js&"
export * from "./shiftReport.vue?vue&type=script&lang=js&"
import style0 from "./shiftReport.vue?vue&type=style&index=0&id=5b6e64e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e64e7",
  null
  
)

component.options.__file = "shiftReport.vue"
export default component.exports